import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getMdCampaigns = (data: PropertyType): Promise<PropertyType> =>
	api.post(`esa-tools/money-drop${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
